import * as PropTypes from 'prop-types'
import errorIcon from '../../assets/icons/error.svg'
import successIcon from '../../assets/icons/success.svg'
import infoAccent from '../../assets/icons/info_blue.svg'
import { Card } from '../ui/card'
import { cn } from '@/lib/utils'

interface FormResponseMessage extends React.HTMLAttributes<HTMLDivElement> {
  type: string
  showIcon?: boolean
  title: string
}

export const FormResponseMessage: React.FC<FormResponseMessage> = ({
  children,
  type,
  showIcon,
  title,
  className,
  ...rest
}) => {
  const getclassName = (type: string): string => {
    switch (type) {
      case 'error':
        return 'bg-destructive-foreground border-destructive'
      case 'warning':
        return 'bg-warning-foreground border-warning'
      case 'success':
        return 'bg-success-foreground border-success'
      default:
        return 'bg-accent-background border-accent'
    }
  }

  const getLiveRegionProps = (type: string): { role: string; 'aria-live': 'polite' | 'assertive' } => {
    if (type === 'error') return { role: 'alert', 'aria-live': 'assertive' }
    return { role: 'status', 'aria-live': 'polite' }
  }

  const liveRegionProps = getLiveRegionProps(type)

  return (
    <Card
      className={cn('mb-6 p-3 w-400px text-sm flex flex-col justify-start items-start formResponseMessage', getclassName(type), className)}
      role={liveRegionProps.role}
      aria-live={liveRegionProps['aria-live']}
      {...rest}
    >
      <div className='flex items-start justify-start'>
        {showIcon && type === 'error' && <img className='w-4 h-4 mr-2' src={errorIcon} alt="error" />}
        {showIcon && type === 'success' && <img className='w-4 h-4 mr-2' src={successIcon} alt="success" />}
        {showIcon && type === 'default' && <img className='w-4 h-4 mr-2' src={infoAccent} alt="info" />}
        <p className='font-semibold text-left'>{title}</p>
      </div>
      <div className='flex flex-row items-center justify-start'>
        {showIcon && <div className='w-4 h-4 mr-3' />}
        {children}
      </div>
    </Card>
  )
}

FormResponseMessage.propTypes = {
  children: PropTypes.node,
  type: PropTypes.string.isRequired,
  showIcon: PropTypes.bool,
  title: PropTypes.string.isRequired

}
